export const getTimePassed = (isoString) => {
	const givenDate = new Date(isoString)

	// Handle invalid date strings
	if (isNaN(givenDate.getTime())) {
		return ''
	}

	const now = new Date() // Get the current date and time
	const timeDiff = now.getTime() - givenDate.getTime() // Time difference in milliseconds

	// Calculate the time difference in various units
	const seconds = Math.floor(timeDiff / 1000)
	const minutes = Math.floor(seconds / 60)
	const hours = Math.floor(minutes / 60)
	const days = Math.floor(hours / 24)
	const weeks = Math.floor(days / 7)

	// Build a descriptive string.  Prioritize the largest unit.
	let timePassedString = ''

	if (weeks > 0) {
		timePassedString = `${weeks} week${weeks > 1 ? 's' : ''} ago`
	} else if (days > 0) {
		timePassedString = `${days} day${days > 1 ? 's' : ''} ago`
	} else if (hours > 0) {
		timePassedString = `${hours} hour${hours > 1 ? 's' : ''} ago`
	} else if (minutes > 0) {
		timePassedString = `${minutes} minute${minutes > 1 ? 's' : ''} ago`
	} else if (seconds > 0) {
		timePassedString = `${seconds} second${seconds > 1 ? 's' : ''} ago`
	} else {
		timePassedString = 'Just now'
	}

	return timePassedString
}

export const getDaysRemaining = (isoString) => {
    const now = new Date()
    const endDate = new Date(isoString)

    const time1 = now.getTime()
    const time2 = endDate.getTime()

    const differenceInMs = Math.abs(time2 - time1)
    const millisecondsInADay = 1000 * 60 * 60 * 24

    const daysBetween = differenceInMs / millisecondsInADay
    return `${Math.round(daysBetween)} days left`
}